import React from "react";
import { getReactionIconSrc } from "../constants/mediaAssets.js";

/**
 * Themed reaction icon. Uses CSS mask so stroke-based SVGs pick up `color` from parent.
 */
const MediaIcon = ({ iconKey, src, alt = "", className = "media-icon", size = 40 }) => {
  const resolved = src || getReactionIconSrc(iconKey);
  if (!resolved) return null;

  const style = {
    width: size,
    height: size,
    WebkitMaskImage: `url(${resolved})`,
    maskImage: `url(${resolved})`,
    WebkitMaskSize: "contain",
    maskSize: "contain",
    WebkitMaskRepeat: "no-repeat",
    maskRepeat: "no-repeat",
    WebkitMaskPosition: "center",
    maskPosition: "center"
  };

  return (
    <span
      className={className}
      style={style}
      role={alt ? "img" : "presentation"}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
    />
  );
};

export default MediaIcon;
